import React from "react";
import {useIntl} from "react-intl";
import {
    BabyButton,
    Button,
    GradientButton,
    SearchInput,
} from "@housebets/housebets-x-package";
import {SearchWrapper, ToolbarWrapper} from "@housebets/housebets-x-package/lib/components/layout/Layout";
import {setLoginType, setSearchGameModalOpen} from "app/store/slices/setting";
import {LoginType} from "app/types/common";
import {ProfileDropdown} from "app/components/features";

import { useProfileToolbarData } from "./hooks/useProfileToolbarData";
import { useGTMEvents } from "app/hooks/useGTMEvents";
import { useDispatch } from "react-redux";
import { config } from "../../../../config";

export const ProfileToolbar: React.FC = () => {
    const { isAuth, isRightMenuOpen, setIsRightMenuOpen, windowSize } = useProfileToolbarData();
    const { registration } = useGTMEvents();
    const { $t } = useIntl();
    const dispatch = useDispatch();

    return (
        <>
            {!isAuth && (
                <ToolbarWrapper>
                    <Button
                        id="signin_button"
                        size={"small-2"}
                        text={$t({id: "SignIn"})}
                        onClick={() => {
                            registration.intent();
                            dispatch(setLoginType(LoginType.LOGIN));
                        }}
                        themeKind="white-black"
                    />
                    <GradientButton
                        id="signup_button"
                        size={"small"}
                        kind="fill"
                        withShine
                        text={$t({id: "SignUp"})}
                        onClick={() => {
                            registration.intent();
                            dispatch(setLoginType(LoginType.REGIST));
                        }}
                    />
                </ToolbarWrapper>
            )}
            {isAuth && (
                <ToolbarWrapper>
                    {windowSize.width > 1024 && (
                        <SearchWrapper>
                            <SearchInput
                                value=""
                                onSubmit={() => {}}
                                inputTheme="blue"
                                placeholder={$t({id: "Search"})}
                                style={{
                                    height: 48,
                                }}
                                buttonType
                                size="default"
                                onClick={() => dispatch(setSearchGameModalOpen(true))}
                            />
                        </SearchWrapper>
                    )}
                    {windowSize.width > 768 && config.enable_chat && (
                        <BabyButton.Chat title="Chat" onClick={() => { setIsRightMenuOpen(!isRightMenuOpen) }} />
                    )}
                    <ProfileDropdown />
                </ToolbarWrapper>
            )}
        </>
    );
};

ProfileToolbar.displayName = "Toolbar.ProfileToolbar";
